import { ConnectionCard } from '../ConnectionCard'
import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function Home({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding-top:64px;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 22px;display:flex;align-items:center;justify-content:space-between;gap:12px")}>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Connect
        </span>
      </div>
      <div style={sx("flex:1;min-height:0;overflow:auto;padding:0 20px 4px;display:flex;flex-direction:column;gap:14px")}>
        <ConnectionCard server="Lithuania #218" />
      </div>
      <div style={sx("height:82px;flex:none;border-top:1px solid var(--border-secondary);background:var(--bg-secondary);display:flex;align-items:flex-start;padding:12px 8px 0")}>
        <button onClick={v.kTabConnect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-accent);-webkit-mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat;mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-accent);font-weight:var(--fw-medium)")}>
            Connect
          </span>
        </button>
        <button onClick={v.kTabProtect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Protect
          </span>
        </button>
        <button onClick={v.kTabMonitor} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;mask:url(/assets/icons/security-score.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Monitor
          </span>
        </button>
      </div>
    </div>
  )
}
